import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { GetTradeOrdersHistoryAction } from 'src/app/angular-wallet-base/actions/wallet.actions';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { OneInchService } from 'src/app/angular-wallet-base/services/one-inch.service';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { getTradeOrdersHistoryLoadedState } from 'src/app/angular-wallet-base/store/wallet';
import { SubscriptionListenerComponent } from 'src/app/angular-wallet-base/SubscriptionListenerComponent';
@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class HistoryComponent extends SubscriptionListenerComponent implements OnInit {

  @Input() orders: any[];

  public tradeHistoryProgress = false;
  public loadedAllOrders = false;

  constructor(
    private oneInchService: OneInchService,
    protected store: Store<AppState>
  ) {
    super(store);
  }

  ngOnInit() {
    Logger.info(this.orders);
    this.subscriptions.add(
      this.oneInchService.orderHistoryProgress.subscribe(status => {
        this.tradeHistoryProgress = status;
      })
    );
    this.subscriptions.add(
      this.store.select(getTradeOrdersHistoryLoadedState).subscribe(status => {
        this.loadedAllOrders = status;
      })
    );
  }

  loadMore() {
    if(!this.tradeHistoryProgress) {
      Logger.info('loading more .  . .');
      this.store.dispatch(new GetTradeOrdersHistoryAction());
    }
  }

}
